"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CANADIAN_PROVINCES_OPTIONS = exports.US_STATES_OPTIONS = exports.COUNTRY_OPTIONS = exports.LOOKUP_KEY_BUSINESS_TYPE = exports.LOOKUP_KEY_BUSINESS_VERTICAL = exports.LOOKUP_KEY_STOCK_EXCHANGE = exports.BUSINESS_TYPE_SOLE_PROP = exports.BUSINESS_TYPE_SOLE_PROP_TAXID = exports.BUSINESS_TYPE_GOVERNMENT = exports.BUSINESS_TYPE_NON_PROFIT = exports.BUSINESS_TYPE_PRIVATE = exports.BUSINESS_TYPE_PUBLIC = exports.CONTACT_EMAIL = exports.CONTACT_NAME = exports.CONTACT_PHONE = exports.ADDRESS_COUNTRY_ID = exports.ADDRESS_POSTAL_CODE = exports.ADDRESS_STREET = exports.ADDRESS_CITY = exports.ADDRESS_STATE = exports.BUSINESS_VERTICAL = exports.BRAND_WEBSITE = exports.STOCK_SYMBOL = exports.STOCK_EXCHANGE = exports.NO_TAX_ID_CONSENT = exports.TAX_ID = exports.BUSINESS_TYPE = exports.BUSINESS_NAME_LEGAL = exports.BUSINESS_NAME_DISPLAY = exports.STYLE_BASE = void 0;
var STYLE_BASE = 'dataCollection10dlc';
/**
 * Fields names:
 */

exports.STYLE_BASE = STYLE_BASE;
var BUSINESS_NAME_DISPLAY = 'businessNameDisplay';
exports.BUSINESS_NAME_DISPLAY = BUSINESS_NAME_DISPLAY;
var BUSINESS_NAME_LEGAL = 'businessNameLegal';
exports.BUSINESS_NAME_LEGAL = BUSINESS_NAME_LEGAL;
var BUSINESS_TYPE = 'businessType';
exports.BUSINESS_TYPE = BUSINESS_TYPE;
var TAX_ID = 'taxId';
exports.TAX_ID = TAX_ID;
var NO_TAX_ID_CONSENT = 'no_taxId_consent';
exports.NO_TAX_ID_CONSENT = NO_TAX_ID_CONSENT;
var STOCK_EXCHANGE = 'businessStockExchange';
exports.STOCK_EXCHANGE = STOCK_EXCHANGE;
var STOCK_SYMBOL = 'businessStockSymbol';
exports.STOCK_SYMBOL = STOCK_SYMBOL;
var BRAND_WEBSITE = 'brandWebsite';
exports.BRAND_WEBSITE = BRAND_WEBSITE;
var BUSINESS_VERTICAL = 'businessVertical';
exports.BUSINESS_VERTICAL = BUSINESS_VERTICAL;
var ADDRESS_STATE = 'addressState';
exports.ADDRESS_STATE = ADDRESS_STATE;
var ADDRESS_CITY = 'addressCity';
exports.ADDRESS_CITY = ADDRESS_CITY;
var ADDRESS_STREET = 'addressStreet';
exports.ADDRESS_STREET = ADDRESS_STREET;
var ADDRESS_POSTAL_CODE = 'addressPostalCode';
exports.ADDRESS_POSTAL_CODE = ADDRESS_POSTAL_CODE;
var ADDRESS_COUNTRY_ID = 'addressCountry';
exports.ADDRESS_COUNTRY_ID = ADDRESS_COUNTRY_ID;
var CONTACT_PHONE = 'contactPhone';
exports.CONTACT_PHONE = CONTACT_PHONE;
var CONTACT_NAME = 'contactName';
exports.CONTACT_NAME = CONTACT_NAME;
var CONTACT_EMAIL = 'contactEmail';
exports.CONTACT_EMAIL = CONTACT_EMAIL;
var BUSINESS_TYPE_PUBLIC = 'PUBLIC';
exports.BUSINESS_TYPE_PUBLIC = BUSINESS_TYPE_PUBLIC;
var BUSINESS_TYPE_PRIVATE = 'PRIVATE';
exports.BUSINESS_TYPE_PRIVATE = BUSINESS_TYPE_PRIVATE;
var BUSINESS_TYPE_NON_PROFIT = 'NON-PROFIT';
exports.BUSINESS_TYPE_NON_PROFIT = BUSINESS_TYPE_NON_PROFIT;
var BUSINESS_TYPE_GOVERNMENT = 'GOVERNMENT';
exports.BUSINESS_TYPE_GOVERNMENT = BUSINESS_TYPE_GOVERNMENT;
var BUSINESS_TYPE_SOLE_PROP_TAXID = 'SOLE-PROP-TAXID';
exports.BUSINESS_TYPE_SOLE_PROP_TAXID = BUSINESS_TYPE_SOLE_PROP_TAXID;
var BUSINESS_TYPE_SOLE_PROP = 'SOLE-PROP';
exports.BUSINESS_TYPE_SOLE_PROP = BUSINESS_TYPE_SOLE_PROP;
var LOOKUP_KEY_STOCK_EXCHANGE = 'STOCK_EXCHANGE';
exports.LOOKUP_KEY_STOCK_EXCHANGE = LOOKUP_KEY_STOCK_EXCHANGE;
var LOOKUP_KEY_BUSINESS_VERTICAL = 'BUSINESS_VERTICAL';
exports.LOOKUP_KEY_BUSINESS_VERTICAL = LOOKUP_KEY_BUSINESS_VERTICAL;
var LOOKUP_KEY_BUSINESS_TYPE = 'BUSINESS_TYPE';
/**
 * Dropdowns data:
 *
 * Note: We will get this data from the BE later on.
 */

exports.LOOKUP_KEY_BUSINESS_TYPE = LOOKUP_KEY_BUSINESS_TYPE;
var COUNTRY_OPTIONS = [{
  label: 'United States',
  value: 'US'
}, {
  label: 'Canada',
  value: 'CA'
}];
exports.COUNTRY_OPTIONS = COUNTRY_OPTIONS;
var US_STATES_OPTIONS = [{
  label: 'Alabama',
  value: 'AL'
}, {
  label: 'Alaska',
  value: 'AK'
}, {
  label: 'Arizona',
  value: 'AZ'
}, {
  label: 'Arkansas',
  value: 'AR'
}, {
  label: 'California',
  value: 'CA'
}, {
  label: 'Colorado',
  value: 'CO'
}, {
  label: 'Connecticut',
  value: 'CT'
}, {
  label: 'Delaware',
  value: 'DE'
}, {
  label: 'Washington DC',
  value: 'DC'
}, {
  label: 'Florida',
  value: 'FL'
}, {
  label: 'Georgia',
  value: 'GA'
}, {
  label: 'Hawaii',
  value: 'HI'
}, {
  label: 'Idaho',
  value: 'ID'
}, {
  label: 'Illinois',
  value: 'IL'
}, {
  label: 'Indiana',
  value: 'IN'
}, {
  label: 'Iowa',
  value: 'IA'
}, {
  label: 'Kansas',
  value: 'KS'
}, {
  label: 'Kentucky',
  value: 'KY'
}, {
  label: 'Louisiana',
  value: 'LA'
}, {
  label: 'Maine',
  value: 'ME'
}, {
  label: 'Maryland',
  value: 'MD'
}, {
  label: 'Massachusetts',
  value: 'MA'
}, {
  label: 'Michigan',
  value: 'MI'
}, {
  label: 'Minnesota',
  value: 'MN'
}, {
  label: 'Mississippi',
  value: 'MS'
}, {
  label: 'Missouri',
  value: 'MO'
}, {
  label: 'Montana',
  value: 'MT'
}, {
  label: 'Nebraska',
  value: 'NE'
}, {
  label: 'Nevada',
  value: 'NV'
}, {
  label: 'New Hampshire',
  value: 'NH'
}, {
  label: 'New Jersey',
  value: 'NJ'
}, {
  label: 'New Mexico',
  value: 'NM'
}, {
  label: 'New York',
  value: 'NY'
}, {
  label: 'North Carolina',
  value: 'NC'
}, {
  label: 'North Dakota',
  value: 'ND'
}, {
  label: 'Ohio',
  value: 'OH'
}, {
  label: 'Oklahoma',
  value: 'OK'
}, {
  label: 'Oregon',
  value: 'OR'
}, {
  label: 'Pennsylvania',
  value: 'PA'
}, {
  label: 'Rhode Island',
  value: 'RI'
}, {
  label: 'South Carolina',
  value: 'SC'
}, {
  label: 'South Dakota',
  value: 'SD'
}, {
  label: 'Tennessee',
  value: 'TN'
}, {
  label: 'Texas',
  value: 'TX'
}, {
  label: 'Utah',
  value: 'UT'
}, {
  label: 'Vermont',
  value: 'VT'
}, {
  label: 'Virginia',
  value: 'VA'
}, {
  label: 'Washington',
  value: 'WA'
}, {
  label: 'West Virginia',
  value: 'WV'
}, {
  label: 'Wisconsin',
  value: 'WI'
}, {
  label: 'Wyoming',
  value: 'WY'
}];
exports.US_STATES_OPTIONS = US_STATES_OPTIONS;
var CANADIAN_PROVINCES_OPTIONS = [{
  label: 'Alberta',
  value: 'Alberta'
}, {
  label: 'British Columbia',
  value: 'British Columbia'
}, {
  label: 'Manitoba',
  value: 'Manitoba'
}, {
  label: 'New Brunswick',
  value: 'New Brunswick'
}, {
  label: 'Newfoundland and Labrador',
  value: 'Newfoundland and Labrador'
}, {
  label: 'Nova Scotia',
  value: 'Nova Scotia'
}, {
  label: 'Ontario',
  value: 'Ontario'
}, {
  label: 'Prince Edward Island',
  value: 'Prince Edward Island'
}, {
  label: 'Quebec',
  value: 'Quebec'
}, {
  label: 'Saskatchewan',
  value: 'Saskatchewan'
}, {
  label: 'Northwest Territories',
  value: 'Northwest Territories'
}, {
  label: 'Nunavut',
  value: 'Nunavut'
}, {
  label: 'Yukon Territories',
  value: 'Yukon Territories'
}];
exports.CANADIAN_PROVINCES_OPTIONS = CANADIAN_PROVINCES_OPTIONS;